module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: (_vm.prefixCls + "-wrapper")
  }, [_c('span', {
    class: _vm.checkboxClass
  }, [_c('span', {
    class: (_vm.prefixCls + "__inner"),
    on: {
      "click": _vm.toggle
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03a1800a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Checkbox/Checkbox.vue
// module id = 71
// module chunks = 0